import { Component, OnInit } from '@angular/core';

@Component({
  template: '',
})
export class BaseComponent {

  constructor() { }

  ngOnInit(): void {
    document.body.classList.add('not-front');
    this.openMenu = window.innerWidth > 480;
  }
  openMenu;

  secondMenu() {
    console.log("this.openMenu",this.openMenu);
    
    this.openMenu = !this.openMenu;
  }

}
